import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import Bold from 'components/Bold';
import { CalibrationId } from 'services/equipmentSets/types';
import PrintSprayWorksheetCalibrationTable from '../PrintSprayWorksheetCalibrationTable';
import { makeSelectCalibrationsEntities } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
    calibrationIndex: number;
}

interface ConnectedProps {
    entities: string;
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetCalibrationSectionComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex, entities, calibrationId, calibrationIndex } =
            this.props;

        return (
            <div className="print-worksheet-page-section">
                <Grid columns="1">
                    <GridRow>
                        <GridColumn>
                            <Bold>{`Calibration ${calibrationIndex}`}</Bold>{' '}
                            <span className="calibration-entities">
                                {entities}
                            </span>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <PrintSprayWorksheetCalibrationTable
                    pageIndex={pageIndex}
                    calibrationId={calibrationId}
                />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entities: makeSelectCalibrationsEntities()
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetCalibrationSectionComponent
);
